<template>
  <div class="relative poppins-font h-screen w-screen overflow-hidden flex flex-col">

    <Header
      :scrolled="isScrolled"
      class="absolute shrink-0 z-10 w-full"
      @scroll-to-products="onScrollToProducts"
    />

    <main
      ref="scrollArea"
      class="flex-1 overflow-y-auto overscroll-contain"
    >
      <router-view v-slot="{ Component }">
        <transition name="page">
          <component :is="Component" :key="$route.path" />
        </transition>
      </router-view>
    </main>
  </div>
</template>

<script>
import Header from "@/components/header.vue";

export default {
  name: "Body",
  components: { Header },

  data() {
    return {
      isScrolled: false,
    };
  },

  watch: {
    $route() {
      this.$refs.scrollArea.scrollTop = 0;
    }
  },

  mounted() {
    this.$refs.scrollArea.addEventListener("scroll", this.handleScroll);
  },

  beforeUnmount() {
    this.$refs.scrollArea.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll(e) {
      this.isScrolled = e.target.scrollTop > 10;
    },
    onScrollToProducts() {
      if (this.$route.path === '/') {
        window.dispatchEvent(new CustomEvent('scroll-to-products'));
      }
    },
  },
};
</script>

<style scoped>
.page-enter-active {
  transition: opacity 0.25s ease;
}
.page-enter-from {
  opacity: 0;
}
</style>
